import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PortalPage } from './pages/portal/portal.page';
import { HomePage } from './pages/home/home.page';
import { AboutUsPage } from './pages/about-us/about-us.page';
import { ContactPage } from './pages/contact/contact.page';
import { LoginPage } from './pages/login/login.page';
import { NewsPage } from "./pages/news/news.page";

const routes: Routes = [
  {
    path: '',
    component: PortalPage,
    children: [
      {
        path: '',
        component: HomePage
      },
      {
        path: 'about-us',
        component: AboutUsPage
      },
      {
        path: 'contact',
        component: ContactPage
      },
      {
        path: 'news',
        component: NewsPage
      }
    ]
  },
  {
    path: 'login',
    component: LoginPage
  }
];

export const routing: ModuleWithProviders = RouterModule.forChild(routes);
